import {FC} from 'react'

const Error404: FC = () => {
  return (
    <>
      <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>Page introuvable</h1>

      <div className='fw-bold fs-3 text-gray-400 mb-15'>
        La page que vous avez cherché n'a pas été trouvée ! <br /> Cliquez ci-dessous pour revenir au tableau de bord
      </div>
    </>
  )
}

export {Error404}
